import {
  ADMIN_ADD_FAILURE,
  ADMIN_ADD_REQUEST,
  ADMIN_ADD_SUCCESS,
  ADMIN_DELETE_FAILURE,
  ADMIN_DELETE_REQUEST,
  ADMIN_DELETE_SUCCESS,
  ADMIN_EDIT_FAILURE,
  ADMIN_EDIT_REQUEST,
  ADMIN_EDIT_SUCCESS,
  ADMIN_VIEW_FAILURE,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_SUCCESS,
  AUTH_RESET_STATE,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  MOBILE_OTP_FAILURE,
  MOBILE_OTP_REQUEST,
  MOBILE_OTP_SUCCESS,
  REDIRECT,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REQUEST_OTP_FAILURE,
  REQUEST_OTP_REQUEST,
  REQUEST_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  RESET_REFRESH_TOKEN_STATE,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  VERIFY_MOBILE_OTP_FAILURE,
  VERIFY_MOBILE_OTP_REQUEST,
  VERIFY_MOBILE_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
} from "./AuthTypes";

// Login
export const loginRequest = (credentials) => ({
  type: LOGIN_REQUEST,
  payload: credentials,
});

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

// Register
export const registerRequest = (credentials) => ({
  type: REGISTER_REQUEST,
  payload: credentials,
});

export const registerSuccess = (user) => ({
  type: REGISTER_SUCCESS,
  payload: user,
});

export const registerFailure = (error) => ({
  type: REGISTER_FAILURE,
  payload: error,
});

//Request OTP
export const requestOtpRequest = (email) => ({
  type: REQUEST_OTP_REQUEST,
  payload: email,
});

export const requestOtpSuccess = (otp) => ({
  type: REQUEST_OTP_SUCCESS,
  payload: otp,
});

export const requestOtpFailure = (error) => ({
  type: REQUEST_OTP_FAILURE,
  payload: error,
});

// Verify OTP
export const verifyOtpRequest = (credentials) => ({
  type: VERIFY_OTP_REQUEST,
  payload: credentials,
});

export const verifyOtpSuccess = (response) => ({
  type: VERIFY_OTP_SUCCESS,
  payload: response,
});

export const verifyOtpFailure = (error) => ({
  type: VERIFY_OTP_FAILURE,
  payload: error,
});

//Request Mobile OTP
export const requestMobileOtpRequest = (mobile) => ({
  type: MOBILE_OTP_REQUEST,
  payload: mobile,
});

export const requestMobileOtpSuccess = (otp) => ({
  type: MOBILE_OTP_SUCCESS,
  payload: otp,
});

export const requestMobileOtpFailure = (error) => ({
  type: MOBILE_OTP_FAILURE,
  payload: error,
});

// Mobile Verify OTP
export const verifyMobileOtpRequest = (credentials) => ({
  type: VERIFY_MOBILE_OTP_REQUEST,
  payload: credentials,
});

export const verifyMobileOtpSuccess = (response) => ({
  type: VERIFY_MOBILE_OTP_SUCCESS,
  payload: response,
});

export const verifyMobileOtpFailure = (error) => ({
  type: VERIFY_MOBILE_OTP_FAILURE,
  payload: error,
});

// Resend OTP
export const resendOtpRequest = (email) => ({
  type: RESEND_OTP_REQUEST,
  payload: email,
});

export const resendOtpSuccess = (otp) => ({
  type: RESEND_OTP_SUCCESS,
  payload: otp,
});

export const resendOtpFailure = (error) => ({
  type: RESEND_OTP_FAILURE,
  payload: error,
});

// Update Password
export const updatePasswordRequest = (passwordData) => ({
  type: UPDATE_PASSWORD_REQUEST,
  payload: passwordData,
});

export const updatePasswordSuccess = (response) => ({
  type: UPDATE_PASSWORD_SUCCESS,
  payload: response,
});

export const updatePasswordFailure = (error) => ({
  type: UPDATE_PASSWORD_FAILURE,
  payload: error,
});

// Change Password
export const changePasswordRequest = (password) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload: password,
});

export const changePasswordSuccess = (payload) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: payload,
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error,
});

// Admin Add
export const adminAddRequest = (adminData) => ({
  type: ADMIN_ADD_REQUEST,
  payload: adminData,
});

export const adminAddSuccess = (response) => ({
  type: ADMIN_ADD_SUCCESS,
  payload: response,
});

export const adminAddFailure = (error) => ({
  type: ADMIN_ADD_FAILURE,
  payload: error,
});

// Admin Edit
export const adminEditRequest = (updatedData) => ({
  type: ADMIN_EDIT_REQUEST,
  payload: updatedData,
});

export const adminEditSuccess = (data) => ({
  type: ADMIN_EDIT_SUCCESS,
  payload: data.updatedAdminData,
});

export const adminEditFailure = (error) => ({
  type: ADMIN_EDIT_FAILURE,
  payload: error,
});

// Admin View
export const adminViewRequest = (adminId) => ({
  type: ADMIN_VIEW_REQUEST,
  payload: adminId,
});

export const adminViewSuccess = (response) => ({
  type: ADMIN_VIEW_SUCCESS,
  payload: response,
});

export const adminViewFailure = (error) => ({
  type: ADMIN_VIEW_FAILURE,
  payload: error,
});

// Delete Admin
export const adminDeleteRequest = (adminId) => ({
  type: ADMIN_DELETE_REQUEST,
  payload: adminId,
});

export const adminDeleteSuccess = (adminId) => ({
  type: ADMIN_DELETE_SUCCESS,
  payload: adminId,
});

export const adminDeleteFailure = (error) => ({
  type: ADMIN_DELETE_FAILURE,
  payload: error,
});

//Refresh Token
export const refreshTokenRequest = (credentials) => ({
  type: REFRESH_TOKEN_REQUEST,
  payload: credentials,
});

export const refreshTokenSuccess = (response) => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload: response,
});

export const refreshTokenFailure = (error) => ({
  type: REFRESH_TOKEN_FAILURE,
  payload: error,
});

export const resetRefreshTokenState = () => ({
  type: RESET_REFRESH_TOKEN_STATE,
});

// Logout
export const logout = () => ({
  type: LOGOUT,
});

// Redirect Action
export const redirect = (payload) => ({
  type: REDIRECT,
  payload,
});

//Reset
export const authResetState = () => ({
  type: AUTH_RESET_STATE,
});
